import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import "./variables.scss";
import "./index.css";
import TemplateDataContext, { TemplateDataContextProvider } from "./Contexts/TemplateData.context";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

const hostname = window.location.hostname;

if (hostname.includes("legalsimpli.com")) {
  document.title = "LEGALSimpli";
} else if (hostname.includes("worksimpli.com")) {
  document.title = "Worksimpli";
} else {
  document.title = "LEGALSimpli";
}
root.render(
  <BrowserRouter>
    <TemplateDataContextProvider>
      <TemplateDataContext.Consumer>{(context) => <App />}</TemplateDataContext.Consumer>
    </TemplateDataContextProvider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
